export default __webpack_public_path__ + "static/media/caricias2.075824d8.png";